import React from 'react';
import { Block, Typography } from '@klp/design';
import { Box, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { CompanyDetails } from './CompanyDetails';
import { useCompanyContext } from './CompanyContext';
import { MANUAL_ORG_NUMBER } from '.';

const useStyles = makeStyles((theme) => ({
    companyInfoBox: {
        padding: theme.spacing(2),
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    companyInfoGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(1),

        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
}));

export const CompanyInfoBox = ({
    formikFirmanavn,
    formikOrganisasjonsnummer,
}: {
    formikFirmanavn?: string;
    formikOrganisasjonsnummer?: string;
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { selectedCompany } = useCompanyContext();

    // On reload in manual mode, selectedCompany is null but Formik has the values
    const isManual =
        selectedCompany?.organisasjonsnummer === MANUAL_ORG_NUMBER ||
        (!selectedCompany && formikOrganisasjonsnummer === MANUAL_ORG_NUMBER);

    const manualName = selectedCompany?.navn || formikFirmanavn || '';

    if (isManual && manualName) {
        return (
            <Box data-testid="company-info-box-manual">
                <Alert severity="info">
                    <Typography variant="h6">{manualName}</Typography>
                    {t('project.formFields.manueltRegistrertInfo')}
                </Alert>
            </Box>
        );
    }

    if (!selectedCompany) return null;

    return (
        <Box className={classes.companyInfoBox} data-testid="company-info-box">
            <Typography variant="h6">
                {selectedCompany.navn} ({selectedCompany.organisasjonsnummer})
            </Typography>
            <Block className={classes.companyInfoGrid}>
                <Box>
                    <CompanyDetails
                        company={selectedCompany}
                        name="registrertIMvaregisteret"
                    />
                    <CompanyDetails
                        company={selectedCompany}
                        name="registrertIForetaksregisteret"
                    />
                    <CompanyDetails
                        company={selectedCompany}
                        name="registreringsdatoEnhetsregisteret"
                    />
                    <CompanyDetails
                        company={selectedCompany}
                        name="registreringsdatoAntallAnsatteNAVAaregisteret"
                    />
                </Box>
                <Box>
                    <CompanyDetails company={selectedCompany} name="konkurs" />
                    <CompanyDetails
                        company={selectedCompany}
                        name="underAvvikling"
                    />
                    <CompanyDetails
                        company={selectedCompany}
                        name="underTvangsavviklingEllerTvangsopplosning"
                    />
                </Box>
            </Block>
        </Box>
    );
};
